const breakdownSections = [
  {
    name: 'Reading: Biography',
    percentCorrect: 67
  },
  {
    name: 'Reading: Hard Sciences',
    percentCorrect: 50
  },
  {
    name: 'Reading: Social Sciences',
    percentCorrect: 44
  },
  {
    name: 'Reading: Humanities',
    percentCorrect: 28
  }
];

const breakdownSections2026 = [
  {
    name: 'Complete the Words',
    percentCorrect: 67
  },
  {
    name: 'Read in Daily Life',
    percentCorrect: 50
  },
  {
    name: 'Academic Passage',
    percentCorrect: 44
  },
  {
    name: 'Choose a Response',
    percentCorrect: 28
  }
];

const scoreSections = [
  {
    name: 'Listening',
    sampleScore: 27,
    scoreRange: 'Score range: 0-30'
  },
  {
    name: 'Writing',
    sampleScore: 20,
    scoreRange: 'Score range: 0-30'
  },
  {
    name: 'Reading',
    sampleScore: 23,
    scoreRange: 'Score range: 0-30'
  },
  {
    name: 'Speaking',
    sampleScore: 27,
    scoreRange: 'Score range: 0-30'
  },
  {
    name: 'Total',
    sampleScore: 97,
    scoreRange: 'Score range: 0-120'
  }
];

const scoreSections2026 = [
  {
    name: 'Listening',
    sampleScore: 4.5,
    scoreRange: 'Score range: 1-6'
  },
  {
    name: 'Writing',
    sampleScore: 5,
    scoreRange: 'Score range: 1-6'
  },
  {
    name: 'Reading',
    sampleScore: 5.5,
    scoreRange: 'Score range: 1-6'
  },
  {
    name: 'Speaking',
    sampleScore: 5,
    scoreRange: 'Score range: 1-6'
  },
  {
    name: 'Total',
    sampleScore: 5,
    scoreRange: 'Score range: 1-6'
  }
];

export default {
  null: { breakdownSections, scoreSections },
  '2026_toefl': { breakdownSections: breakdownSections2026, scoreSections: scoreSections2026 }
};
